import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || (window.location.origin + '/api');

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ahoow_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ahoow_token');
      localStorage.removeItem('ahoow_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
